import React from 'react';

import { Box, Card, Heading, Separator, Spinner, Text } from '@betterment/samba-react';
import { ErrorBoundary, SambaAutoLink } from '@betterment/shared-components';

import { ContributionRecommendationRow } from './ContributionRecommendationRow';
import { HowToSaveCardLoadingState } from './loading-state/HowToSaveLoadingState';

import { urlBuilder } from '../../../../Shared/urlBuilder';
import { useForecasterPurposeProjection } from '../../context/ForecasterPurposeProjectionContext';

const HowToSaveCardView = () => {
  const data = useForecasterPurposeProjection();

  if (!data?.purpose) return <HowToSaveCardLoadingState />;

  const { isLoading, purpose } = data;

  if (purpose.__typename !== 'PurposeRetirementGrowth' || !purpose.retirementGrowthProjection) {
    return null;
  }

  const { subtitle, contributionRecommendations } = purpose.retirementGrowthProjection.savingsPlan;

  const returnToUrl = urlBuilder.appPurposeForecaster.absolute({ purposeId: purpose.id });

  return (
    <Card css={{ position: 'relative' }}>
      {isLoading && (
        <Box
          css={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1,
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
          }}
        >
          <Spinner />
        </Box>
      )}

      <Card.Content css={{ display: 'flex', flexDirection: 'column', padding: 'space.300', gap: 'space.300' }}>
        <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.100' }}>
          <Heading variant="title200">How to save</Heading>
          <Text variant="text100">{subtitle}</Text>
        </Box>

        <Separator />

        {contributionRecommendations.map(recommendation => (
          <React.Fragment key={recommendation.title}>
            <ContributionRecommendationRow contributionRecommendation={recommendation} returnToUrl={returnToUrl} />
            <Separator />
          </React.Fragment>
        ))}
        <Text variant="text100">
          For the most accurate advice on how to save,{' '}
          <SambaAutoLink to={urlBuilder.appExternalAccountSetup.absolute()}>
            connect your external retirement accounts
          </SambaAutoLink>
          .
        </Text>
      </Card.Content>
    </Card>
  );
};

export const HowToSaveCard = () => {
  return (
    <ErrorBoundary fallbackType="none">
      <HowToSaveCardView />
    </ErrorBoundary>
  );
};
